import { render, staticRenderFns } from "./AppleLogo.vue?vue&type=template&id=61b216a4&scoped=true"
import script from "./AppleLogo.vue?vue&type=script&lang=js"
export * from "./AppleLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b216a4",
  null
  
)

export default component.exports